import React from 'react'
import { Services } from '@/services/services'
import { Translates } from '@/services/repository/i18n'

import './CommunalHeader.css'
import { useNavigate } from 'react-router-dom'
import { squareLogo } from '@/env/config'

export interface CommunalHeaderParams {
  services: Services
  translates: Translates
  pageId: string
}

export const CommunalHeader = (params: CommunalHeaderParams) => {
  const { translates } = params
  const navigate = useNavigate()

  return <div className='communal-header'>
    <div className='logo-wrap'>
      <img src={squareLogo} />
    </div>
    <h2 className='title'>
      {translates.for('menus.communal.unauthorized.'+params.pageId)}
    </h2>
    <nav className='top-nav'>
      <a onClick={() => navigate('/login')} className={params.pageId==='login' ? 'current' : ''}>{translates.for('menus.communal.unauthorized.login')}</a>
      <a onClick={() => navigate('/registration')} className={params.pageId==='registration' ? 'current' : ''}>{translates.for('menus.communal.unauthorized.registration')}</a>
    </nav>
  </div>
}